var Shopify = Shopify || {};

/* Kit Matcher */
if ($('.robolink-matcher').length > 0) {

    // Slider for the Kit Matcher
    const matcher = $('.matcher');
    const matcherContainer = $('.matcher__questions');
    const matcherItems = $('.matcher__questions___item', matcher);
    const robots = getRobots();
    const kits = getKits();
    const classrooms = getClassrooms();

    const matcherFilters = [];
    const firstProduct = [];
    const selectedAnswers = [];

    $(document).ready(function () {
        fixSlidesPosition();
        checkNextBtnStatus();
        checkBackBtnStatus();
    });

    $(document).on('click', '.matcher__next:not(.disabled)', function (event) {
        event.preventDefault();

        const selectedQuestion = getCurrentQuestion(matcher);
        const nextQuestion = getNextQuestion(matcher);
        const index = $(selectedQuestion).index();
        addFilterSelected(index, selectedQuestion);

        // Add question
        addSelectedQuestions(index, selectedQuestion);

        moveToSlideKitMatcher(matcherContainer, selectedQuestion, nextQuestion);

        checkNextBtnStatus();
        checkBackBtnStatus();
        showResults(nextQuestion);
    });

    $(document).on('click', '.matcher__back:not(.disabled)', function (event) {
        event.preventDefault();

        const selectedQuestion = getCurrentQuestion(matcher);
        const prevQuestion = getPreviousQuestion(matcher);

        moveToSlideKitMatcher(matcherContainer, selectedQuestion, prevQuestion);

        checkNextBtnStatus();
        checkBackBtnStatus();
    });

    $(document).on('change', '.matcher__questions___item input', function (event) {
        checkNextBtnStatus();
    });
    function moveToSlideKitMatcher(sliderContainer, currentSlide, targetSlide) {
        const amountToMove = $(targetSlide).css('left');
        $(sliderContainer).css({
            transform: 'translate(-' + amountToMove + ', 0)'
        });
        $(currentSlide).removeClass('current');
        $(targetSlide).addClass('current');
    }

    function checkNextBtnStatus() {
        $('.matcher__next').addClass('disabled');

        if (isOneOptionSelected()) {
            $('.matcher__next').removeClass('disabled');
        }
    }

    function checkBackBtnStatus() {
        const selectedQuestion = getCurrentQuestion(matcher);
        const index = $(selectedQuestion).index();

        $('.matcher__back').addClass('disabled');

        if (index > 0) {
            $('.matcher__back').removeClass('disabled');
        }
    }

    function isOneOptionSelected() {
        const selectedQuestion = getCurrentQuestion(matcher);
        const options = $('input:checked', selectedQuestion);

        return options.length > 0;
    }

    function fixSlidesPosition() {
        const matcherWidth = matcherContainer.width() + 30;

        // Arrange the slides next one another
        arrangeSlidesKitMatcher(matcherItems, matcherWidth);
    }
    function arrangeSlidesKitMatcher(slides, slideWidth) {
        for (let i = 0; i < slides.length; i++) {
            positionSlideKitMatcher(slides[i], i * slideWidth);
        }
    }
    function positionSlideKitMatcher(slide, left) {
        $(slide).css('left', left + 'px');
    }

    function filterObject(object, valuesToRemove) {
        const result = {};
        Object.keys(object).forEach(key => {
            if (!valuesToRemove.includes(key)) {
                result[key] = object[key];
            }
        });

        return result;
    }

    function getCurrentQuestion(slider) {
        return $('.matcher__questions___item.current', slider);
    }

    function getNextQuestion(slider) {
        return getCurrentQuestion(slider).next();
    }

    function getPreviousQuestion(slider) {
        return getCurrentQuestion(slider).prev();
    }

    function addFilterSelected(index, slide) {
        matcherFilters[index] = '';
        if ($(`input[name="question${index}"]`, slide).attr('type') === 'radio') {
            if (
                $(`input[name="question${index}"]:checked`, slide).length > 0 &&
                $(`input[name="question${index}"]:checked`, slide).val() !== ''
            ) {
                matcherFilters[index] = JSON.parse($(`input[name="question${index}"]:checked`, slide).val());

                checkFirstProduct($(`input[name="question${index}"]:checked`, slide), index);
            }
        } else if ($(`input[name="question${index}"]`, slide).attr('type') === 'checkbox') {
            let aux = [];
            $(`input[name="question${index}"]:checked`, slide).each(function () {
                if ($(this).val() !== '') {
                    if (aux.length === 0) {
                        aux = JSON.parse($(this).val()).robots;
                    } else {
                        aux = arrayIntersection(aux, JSON.parse($(this).val()).robots);
                    }
                }
            });

            if (aux.length > 0) {
                matcherFilters[index] = { robots: aux };
            }
        }
    }

    function showResults(slide) {
        if (slide.hasClass('matcher__questions___result')) {
            const products = getTheResult();

            sessionStorage.product_keys = JSON.stringify(products);
            sessionStorage.first_product = JSON.stringify(firstProduct);
            sessionStorage.selected_answers = JSON.stringify(selectedAnswers);

            window.setTimeout(function () {
                // Move to a new location or you can do something else
                window.location.href = `${location.protocol}//${window.location.hostname}/pages/kitmatcher-result`;
            }, 3000);
        }
    }

    function getTheResult() {
        const { filteredRobots, filteredKits, filteredClassrooms } = removeSelected();

        const result1 = combineObjects(filteredRobots, filteredKits);
        const result2 = combineObjects(filteredRobots, filteredClassrooms);

        return { ...result1, ...result2 };
    }

    function combineObjects(obj1, obj2) {
        if (typeof obj1 !== 'undefined' && typeof obj2 !== 'undefined') {
            const result = {};
            Object.keys(obj1).forEach(key1 => {
                Object.keys(obj2).forEach(key2 => {
                    result[`${key1}_${key2}`] = `${obj1[key1]} ${obj2[key2]}`;
                });
            });

            return result;
        } else {
            return {};
        }
    }

    function arrayIntersection(arr1, arr2) {
        return arr1.filter(x => arr2.includes(x));
    }

    function removeSelected() {
        let filteredRobots = robots;
        let filteredKits = kits;
        let filteredClassrooms = classrooms;

        matcherFilters.flatMap(element => {
            if (element.hasOwnProperty('robots')) {
                if (element.robots === 'all') {
                    filteredRobots = {};
                } else {
                    filteredRobots = filterObject(filteredRobots, element.robots);
                }
            }

            if (element.hasOwnProperty('kits')) {
                if (element.kits === 'all') {
                    filteredKits = {};
                } else {
                    filteredKits = filterObject(filteredKits, element.kits);
                }
            }

            if (element.hasOwnProperty('classrooms')) {
                if (element.classrooms === 'all') {
                    filteredClassrooms = {};
                } else {
                    filteredClassrooms = filterObject(filteredClassrooms, element.classrooms);
                }
            }
        });

        return { filteredRobots, filteredKits, filteredClassrooms };
    }

    /**
     * Check if the selected question has the first product data attribute.
     *
     * NOTE: Just for radio button.
     */
    function checkFirstProduct(inputSelected, index) {
        firstProduct[index] = inputSelected.data('first-product') ?? '';
    }

    function addSelectedQuestions(index, slide) {
        selectedAnswers[index] = {};
        const questionItem = $(`input[name="question${index}"]:checked`, slide).closest('.matcher__questions___item');
        const questionText = $('p', questionItem).html();
        selectedAnswers[index].question = questionText;

        if ($(`input[name="question${index}"]`, slide).attr('type') === 'radio') {
            const answerItem = $(`input[name="question${index}"]:checked`, slide).closest('label');
            const answerText = $(answerItem).text().replaceAll('\t', '').replaceAll('\n', '');

            selectedAnswers[index].answers = [answerText];
        } else if ($(`input[name="question${index}"]`, slide).attr('type') === 'checkbox') {
            const aux = [];
            $(`input[name="question${index}"]:checked`, slide).each(function () {
                const answerItem = $(this).closest('label');
                const answerText = $(answerItem).text().replaceAll('\t', '').replaceAll('\n', '');
                aux.push(answerText);
            });

            if (aux.length > 0) {
                selectedAnswers[index].answers = aux;
            }
        }
    }
}

if ($('.robolink-matcher-result').length > 0) {
    if (typeof sessionStorage.product_keys !== 'undefined') {
        const products = JSON.parse(sessionStorage.product_keys);
        const productsMessage = [];

        // To test specific products
        // let products = {r3_k4: "", r2_k4: ""};
        if ($.isEmptyObject(products) === false) {
            Object.keys(products).forEach(key => {
                const result = `${key}`;
                const parts = result.split('_');
                let toShowId = '';

                productsMessage.push(products[key]);

                if (isSingle(parts[1])) {
                    toShowId = `#${parts[0]}_single`;
                } else {
                    toShowId = `#${parts[0]}_multiple`;
                }

                // Display the product
                $(toShowId).addClass('choose');

                const accessories = hasAccessories(parts[1]);
                const professionalDevelopment = hasDevelopment(parts[1]);

                // Display the accessories
                if (accessories) {
                    $('.kit-result__accessories', toShowId).addClass('choose');
                    $('.robolink-ajax-product-form', toShowId).data('accessories', 'yes');
                }

                // Display the PD
                if (professionalDevelopment) {
                    $('.kit-result__development', toShowId).addClass('choose');
                    $('.robolink-ajax-product-form', toShowId).data('professional_development', 'yes');
                }

                // Update the price in the buy button
                changeTheBtnPriceKitMatcher(toShowId, accessories, professionalDevelopment);
            });
        } else {
            showKitMatcherEmptyText();
        }

        sortResults();

        setProductsIntoContactForm(productsMessage);
    } else {
        showKitMatcherEmptyText();
    }
}
function changeTheBtnPriceKitMatcher(wrapper, hasAccessories, professionalDevelopment) {
    let total = 0;
    $('.product_variant_to_add', wrapper).each(function () {
        if (shouldAddKitMatcher(this, hasAccessories, professionalDevelopment) === true) {
            const productId = $(this).data('productid');
            const productVariantId = parseInt($(this).val());
            const auxProduct = JSON.parse(document.querySelector('.ProductJsonMultiple-' + productId).innerHTML);
            const selectedVariant = auxProduct.variants.find(variant => variant.id === productVariantId);
            const price = parseInt(selectedVariant.price);
            const amount = $(this).data('amount') || 1;
            total += price * parseInt(amount);
        }
    });
    $('.robolink_add_to_cart_multiple span span', wrapper).html(theme.Shopify.formatMoney(total, theme.moneyFormat));
}
/**
 * This function is used to choose the products that must be added to the cart.
 *
 * @param {*} product The hidden input with the product information.
 * @param {*} hasAccessories If I have to add the products accessories.
 * @param {*} professionalDevelopment If I have to add the products professional_development.
 * @returns boolean
 */
function shouldAddKitMatcher(product, hasAccessories, professionalDevelopment) {
    let add = false;
    if ($(product).data('type') === 'product' || $(product).data('type') === '') {
        const prodId = $(product).data('productid');
        if ($('#product' + prodId + '[type="checkbox"]').length > 0) {
            /* Related products */
            if ($('#product' + prodId + '[type="checkbox"]').is(':checked')) {
                add = true;
            }
        } else {
            /* Kit matcher */
            add = true;
        }
    } else if ($(product).data('type') === 'accessory' && (hasAccessories === 'yes' || hasAccessories === true)) {
        add = true;
    } else if (
        $(product).data('type') === 'professional_development' &&
        (professionalDevelopment === 'yes' || professionalDevelopment === true)
    ) {
        add = true;
    }
    return add;
}

function showKitMatcherEmptyText() {
    $('.non-empty-text').hide();
    $('.empty-text').show();
}

function sortResults() {
    const priorityProduct = getFirstProduct();
    if (priorityProduct) {
        const singleBlock = `#${priorityProduct}_single`;
        const multipleBlock = `#${priorityProduct}_multiple`;
        $('#robolink-list-results .shopify-section').each(function (index) {
            let firstProduct = '';
            if ($(singleBlock, $(this)).length > 0) {
                firstProduct = $(this);

                $(this).remove();

                $('#robolink-list-results').prepend(firstProduct);
            }

            firstProduct = '';
            if ($(multipleBlock, $(this)).length > 0) {
                firstProduct = $(this);

                $(this).remove();

                $('#robolink-list-results').prepend(firstProduct);
            }
        });
    }
}

function getFirstProduct() {
    let firstProduct = '';
    if (sessionStorage.first_product) {
        firstProduct = JSON.parse(sessionStorage.first_product)
            .filter(item => item)
            .pop();
    }

    return firstProduct;
}

/**
 * Define all robots.
 *
 * Notes:
 * - The key value must be the ID. So you don't have to change because in the backend this ID is used for the description.
 * - The key value could be disordered, as long as it's always unique.
 * - The key must start with "r". Example: "r1", "r2", "r3", "r4"...
 */
function getRobots() {
    return {
        r1: 'Rokit Smart',
        /* 'r2': 'CoDrone Pro', */
        r3: 'CoDrone Mini',
        r4: 'Zumi',
        r5: 'Buildy Bots',
        r6: 'CoDrone EDU'
    };
}

/**
 * Define the kits options.
 *
 * Note: Kit options are with only one robot.
 *
 * Notes:
 * - See the notes for the robots about the keys.
 * - The key must start with "a". Example: "k1", "k2", "k3", "k4"...
 */
function getKits() {
    return {
        k1: '1 kit (no accessories)',
        k2: '1 kit + PD (no accessories)',
        k3: '1 kit + accessories',
        k4: '1 kit + accessories + PD'
    };
}

/**
 * Define the classrooms options.
 *
 * Note: Classrooms options are with more than one robot.
 *
 * Notes:
 * - See the notes for the robots about the keys.
 * - The key must start with "na". Example: "c1", "c2", "c3", "c4"...
 */
function getClassrooms() {
    return {
        c1: 'classroom set (no accessories)',
        c2: 'classroom set + PD (no accessories)',
        c3: 'classroom set + accessories',
        c4: 'classroom set + accessories + PD'
    };
}

/**
 * Define is a single robot.
 */
function isSingle(keyPart) {
    const kits = getKits();

    return kits[keyPart] !== undefined;
}

/**
 * Define is the option has accessories
 */
function hasAccessories(keyPart) {
    const withAccessories = ['k3', 'k4', 'c3', 'c4'];

    return withAccessories.includes(keyPart);
}

/**
 * Define is the option has accessories
 */
function hasDevelopment(keyPart) {
    const withDevelopment = ['k2', 'k4', 'c2', 'c4'];

    return withDevelopment.includes(keyPart);
}

/**
 * Set the result products into the contact form
 */
function setProductsIntoContactForm(productsMessage) {
    if (productsMessage.length > 0) {
        const startMessage = "Based on your answers, we've recommended the following products:\n";
        const last = productsMessage.pop();
        const result = productsMessage.join(', ') + ' and ' + last;

        $('.robolink-contact .robolink-contact__message').val(startMessage + result);
    }
}
